import { MunicipalityType } from '../../buy-process-form-types';
import { Keys, Labels } from '../../../../utils/types/keys';

export type CompanyDetailsStoreState = CompanyDetailsFormState & {
  id?: string;
  orderId?: string;
};

export type CompanyDetailsFormState = {
  co: string;
  desiredCompanyName: string;
  firstAlternativeCompanyName: string;
  secondAlternativeCompanyName: string;
  nameReview: boolean;
  address: string;
  postalCode: string;
  city: string;
  municipality: MunicipalityType;
  templateSelect: string;
  businessDescription: string;
  taxHelp: boolean;
};

export const CompanyDetailsFieldName: Keys<CompanyDetailsFormState> = {
  co: 'co',
  address: 'address',
  businessDescription: 'businessDescription',
  city: 'city',
  desiredCompanyName: 'desiredCompanyName',
  firstAlternativeCompanyName: 'firstAlternativeCompanyName',
  municipality: 'municipality',
  nameReview: 'nameReview',
  postalCode: 'postalCode',
  secondAlternativeCompanyName: 'secondAlternativeCompanyName',
  taxHelp: 'taxHelp',
  templateSelect: 'templateSelect',
};

export const CompanyDetailsFieldLabel: Labels<CompanyDetailsFormState> = {
  co: 'C/O',
  address: 'Utdelningsadress',
  businessDescription: 'Verksamhetsbeskrivning',
  city: 'Ort',
  desiredCompanyName: 'Önskat företagsnamn',
  firstAlternativeCompanyName: 'Alternativt företagsnamn 1',
  municipality: 'Styrelsens säte (kommun)',
  nameReview: 'Namngranskning',
  postalCode: 'Postnummer',
  secondAlternativeCompanyName: 'Alternativt företagsnamn 2',
  taxHelp: 'Hjälp med ansökan om f-skatt, moms och arbetsgivare',
  templateSelect: 'Välj en mall',
};
